import axios from 'axios';
import type { User } from '@/models/user';

class UserWebservice {
    /**
     * Call the login method on api
     *
     * @param email E-Mail
     * @param password Password
     */
    public login(email: string, password: string) {
        return axios.post('/auth/login', {
            email,
            password,
        });
    }

    public register(user: User, token: string) {
        return axios.post('/auth/register', {
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            password: user.password,

            token,

            address: user.address,
            address_addition: user.address_addition,
            postcode: user.postcode,
            city: user.city,
            country: user.country,
        });
    }

    public update(user: User) {
        return axios.post('/auth/updateAccountInfo', {
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            current_password: user.password,
            new_password: user.new_password,

            address: user.address,
            address_addition: user.address_addition,
            postcode: user.postcode,
            city: user.city,
            country: user.country,
        });
    }

    public logout() {
        return axios.post('/auth/logout');
    }

    public getUserInfo() {
        return axios.get('/auth/userinfo');
    }

    public confirmEmail(emailConfirmationToken: string) {
        return axios.post('/auth/emailConfirmation', {
            email_confirmation_token: emailConfirmationToken,
        });
    }

    public resendEmailConfirmationToken() {
        return axios.post('/auth/resendEmailConfirmationToken', {});
    }

    public forgotPassword(user: User) {
        return axios.post('/auth/forgotPassword', {
            email: user.email,
        });
    }

    public resetPassword(token: string, user: User) {
        return axios.post('/auth/resetPassword', {
            token,
            password: user.password,
        });
    }
}

export const userWebservice = new UserWebservice();
